import React, { useState, useEffect } from 'react';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import IconButton from '@material-ui/core/IconButton';
import firebase from 'firebase/app';
import { useSelector, useDispatch } from 'react-redux';
import { getIsSignedIn } from 'reducks/users/userSlice';
import { dialogOpenAction } from 'reducks/dialog/dialogSlice';
import { db } from 'firebase/index';

interface PROPS {
  id: string;
  uid: string;
  noCount?: boolean;
}

const ContestVote: React.FC<PROPS> = ({ id, uid, noCount }) => {
  const dispatch = useDispatch();
  const [voteArray, setVoteArray] = useState<string[]>([]);
  const [count, setCount] = useState<number>(0);
  const postRef = db.collection('posts').doc(id);
  const isSignedIn = useSelector(getIsSignedIn);

  useEffect(() => {
    const unSub = postRef.onSnapshot((snapshot) => {
      const data = snapshot.data();
      if (data.contestUid) {
        const contestUid = data.contestUid;
        const contestCount = data.contestCount;
        setVoteArray(contestUid);
        setCount(contestCount);
      }
    });
    return () => {
      unSub();
    };
  }, []);

  console.log(voteArray);

  const vote = (event: any) => {
    event.stopPropagation();
    if (isSignedIn) {
      if (voteArray.includes(uid)) {
        postRef.set(
          {
            contestUid: firebase.firestore.FieldValue.arrayRemove(uid),
            contestCount: firebase.firestore.FieldValue.increment(-1),
          },
          { merge: true }
        );
      } else {
        postRef.set(
          {
            contestUid: firebase.firestore.FieldValue.arrayUnion(uid),
            contestCount: firebase.firestore.FieldValue.increment(1),
          },
          { merge: true }
        );
      }
    } else {
      dispatch(dialogOpenAction({ type: 'signin', title: 'ログイン' }));
    }
  };
  return (
    <div>
      <IconButton onClick={vote}>
        <HowToVoteIcon color={voteArray.includes(uid) ? 'primary' : 'inherit'} />
      </IconButton>
      {!noCount && <span style={{ marginBottom: '-10px' }}>{count}</span>}
    </div>
  );
};

export default ContestVote;
